module.exports = __webpack_public_path__ + "img/juxueIcon2.922cde95.png";